import { Form, Segment, Message, Button } from 'semantic-ui-react'
import React, { useEffect, useState } from 'react'
import { useForm, useFormState } from 'react-final-form'

import {
  ALL_SUBDIVISION_OPTIONS,
  removeLocalizationsFromSubdivisions,
  SubdivisionOption,
} from '../../../utils/localizations/localizationOptions'
import { Details } from './Details'
import { Field } from './FieldAdapter'
import { Images } from './Images'
import { Localization } from '../../../hooks/useLocalizations'
import { ProductLocalizedKeys } from '../form/types'

export const CreateLocalizationForm = ({
  product,
  localizations,
  actions: Actions = DefaultActions,
}: {
  product: ProductLocalizedKeys
  localizations?: Localization[]
  actions?: React.FC
}) => {
  const [subdivisionOptions, setSubdivisionOptions] = useState<SubdivisionOption[]>([])
  const { submitError } = useFormState()
  const { submit } = useForm()

  useEffect(() => {
    const filteredSubdivisions = removeLocalizationsFromSubdivisions(
      ALL_SUBDIVISION_OPTIONS,
      localizations
    )
    setSubdivisionOptions(filteredSubdivisions)
  }, [localizations])

  return (
    <Form onSubmit={submit} error={!!submitError}>
      <Segment attached style={{ borderTop: 'none' }}>
        <Field name="state_selector">
          {({ input, meta }) => {
            return (
              <>
                <Form.Select
                  label="Select a state:"
                  selection
                  required
                  placeholder="State"
                  selectOnBlur={false}
                  options={subdivisionOptions}
                  onChange={(_, { value }) => input.onChange(value)}
                  value={input.value}
                  error={meta.error && meta.touched && { content: meta.error }}
                />
              </>
            )
          }}
        </Field>

        <Details product={product} />
        <Images product={product} />

        {submitError && <Message error header={submitError.name} content={submitError.message} />}
      </Segment>

      <Segment attached textAlign="right">
        <Actions />
      </Segment>
    </Form>
  )
}

const DefaultActions = () => {
  const { submitting, pristine } = useFormState()
  return (
    <Button type="submit" primary disabled={submitting || pristine}>
      Submit
    </Button>
  )
}
